Ext.define('SA.data.CSV', {
    singleton: true,

    attemptParse(file) {
        return new Promise(resolve => {
            var data = [];

            Papa.parse(file, {
                error: () => resolve({error: true}),
                skipEmptyLines: 'greedy',

                chunk: results => {
                    data.push(...results.data);
                },

                complete: () => {
                    var headerNames = (data.length ? data[0] : []).map(name => name.trim()),
                        transformRow = row => row.map(value => value.trim() || null),
                        rows = data.slice(1).map(transformRow);

                    resolve({data: {headerNames, rows}});
                }
            });
        });
    }
});